import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App.tsx'
import './index.css'

// Build info logging
const buildDateTime = new Date().toLocaleDateString('en-US', {
  month: 'short',
  day: 'numeric',
  year: 'numeric'
}) + ' at ' + new Date().toLocaleTimeString('en-US', {
  hour: '2-digit',
  minute: '2-digit',
  hour12: false
})

const version = '0.3.0'
const environment = import.meta.env.MODE === 'development' ? 'dev' : 'prod'

console.log(`Nazwolab 2025•v${version} ${environment}`)
console.log(`Built ${buildDateTime}`)

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
)